export default __webpack_public_path__ + "assets/models/26d3a263649fa52eea083a57b81d31b9.glb";